/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-named-default */
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import PieChart from 'components/PieChart'
import { get } from 'services/api'
import { chartColors } from 'utils/Colors'
import { default as lodash } from 'lodash'
import styles from './styles'

import { KEYS, TRANSLATED_KEYS } from './keys'

const Statistics = () => {
  const token = useSelector(state => state.auth.access_token)
  const classes = styles()
  const [data, setData] = useState()
  const [labels, setLabels] = useState([])
  const [overallValues, setOverallValues] = useState([])
  const [monthlyValues, setMonthlyValues] = useState([])
  const titles = ["Resumo das Revisões", "Background Check", "Análise de Crédito"]
  
  const load = useCallback(async() => {
    const res = await get({
      url: '/applications/stats',
      token,
    })
    if (res)
      setData(res)
    else
      console.error(res)
  }, [setData, token])
  
  useEffect(() => {
    load()
  }, [load])
  
  useEffect(() => {
    if (data) {
      const labelList = KEYS.map(keychain => 
        Object.keys(
          lodash.pick(data?.overall_stats, keychain),
        ),
      )
      const translatedLabels = labelList.map(keychain => keychain.map(key => TRANSLATED_KEYS[key]))
      const overallValuesList = labelList.map(keychain => keychain.map(key => data.overall_stats[key]))
      const monthlyValuesList = labelList.map(keychain => keychain.map(key => data.monthly_stats[key]))
      
      setLabels(translatedLabels)
      setOverallValues(overallValuesList)  
      setMonthlyValues(monthlyValuesList)  
    }
  }, [data])
  
  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <h2>
          Estatísticas
        </h2>
      </div>
      <div className={classes.content}>
        <div className={classes.contentWrapper}>
          <h3> 
            Visão Geral
          </h3>
          <div className={classes.chartRow}>
            {
              labels.map((label, index) => (
                <PieChart 
                  key={index}
                  data={overallValues[index]} 
                  labels={label} 
                  title={titles[index]}
                  colors={chartColors[index]}
                />
              ))
            }
          </div>
        </div>
        <div className={classes.contentWrapper}>
          <h3>
            Dados do mês
          </h3>
          <div className={classes.chartRow}>
            {
              labels.map((label, index) => (
                <PieChart 
                  key={index}
                  data={monthlyValues[index]} 
                  labels={label} 
                  title={titles[index]}
                  colors={chartColors[index]}
                />
              ))
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Statistics
